var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.listaPrazoPagto,"item-text":"cdPrefDup","item-value":"cdPrefDup","label":"Prefixo Dup.","outlined":"","hide-details":"","readonly":_vm.readonly,"dense":_vm.dense},on:{"change":_vm.onSelectPrefDup},model:{value:(_vm.cdPrazo),callback:function ($$v) {_vm.cdPrazo=$$v},expression:"cdPrazo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }